import React from 'react';

// Location panel — M5 structured address
export const LocationPanel = ({ form, onChange }) => (
  <div className="panel" style={{ padding: 18, marginBottom: 14 }} data-testid="address-panel">
    <div style={{ marginBottom: 10 }}>
      <b style={{ fontSize: 15 }}>Location</b>
      <small style={{ display: 'block', color: 'var(--mute)', marginTop: 2, fontSize: 12.5 }}>
        We use these fields for your public shop page, Google Maps embed and local search.
      </small>
    </div>

    {/* Migration nudge — visible only for shops that have a
        legacy free-text `address` but no structured fields
        yet. */}
    {!form.address_line_1 && !form.city && !form.postcode && form.address && (
      <div
        data-testid="address-migration-notice"
        style={{
          fontSize: 'var(--fs-sm)', lineHeight: 1.45,
          background: 'var(--amber-soft)',
          border: '1px solid var(--amber)',
          color: 'var(--ink)',
          borderRadius: 'var(--r-md)', padding: '8px 10px',
          marginBottom: 12,
        }}
      >
        We upgraded addresses to structured fields for better map results. Your current address is shown below — please split it into the four fields (postcode required) and save.
        <div style={{ marginTop: 6, fontStyle: 'italic', color: 'var(--mute)' }}>
          Current: {form.address}
        </div>
      </div>
    )}

    <div className="field">
      <label>
        Building number or name + street
        <span className="hint">e.g. &quot;14 Manchester Road&quot; or &quot;Flat 3, The Old Bakery&quot;</span>
      </label>
      <input
        className="inp"
        type="text"
        value={form.address_line_1}
        onChange={(e) => onChange({ address_line_1: e.target.value })}
        placeholder="14 Manchester Road"
        data-testid="field-address-line-1"
      />
    </div>

    <div className="field">
      <label>Line 2 <span className="hint">optional — estate, suite, unit</span></label>
      <input
        className="inp"
        type="text"
        value={form.address_line_2}
        onChange={(e) => onChange({ address_line_2: e.target.value })}
        placeholder="Optional"
        data-testid="field-address-line-2"
      />
    </div>

    <div className="field-row" style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 12 }}>
      <div className="field">
        <label>Town or city</label>
        <input
          className="inp"
          type="text"
          value={form.city}
          onChange={(e) => onChange({ city: e.target.value })}
          placeholder="Oldham"
          data-testid="field-city"
        />
      </div>
      <div className="field">
        <label>
          Postcode <span style={{ color: 'var(--danger, #dc2626)' }}>*</span>
        </label>
        <input
          className="inp"
          type="text"
          value={form.postcode}
          onChange={(e) => onChange({ postcode: e.target.value.toUpperCase() })}
          placeholder="OL1 3EB"
          maxLength={12}
          data-testid="field-postcode"
          style={{ textTransform: 'uppercase' }}
        />
      </div>
    </div>

    {/* Preview of the assembled block for legacy consumers */}
    {(form.address_line_1 || form.city || form.postcode) && (
      <div
        data-testid="address-preview"
        style={{
          marginTop: 10, fontSize: 12.5, color: 'var(--mute)',
          background: 'var(--paper, #fafafa)',
          border: '1px solid var(--line)',
          borderRadius: 8, padding: '8px 10px',
        }}
      >
        <b style={{ color: 'var(--ink)', fontSize: 12, textTransform: 'uppercase', letterSpacing: '0.04em' }}>Preview</b>
        <div style={{ marginTop: 4 }}>
          {[form.address_line_1, form.address_line_2, form.city, form.postcode].filter(Boolean).join(', ') || 'Fill in the fields above to see the address preview.'}
        </div>
      </div>
    )}
  </div>
);
